import Model from 'models/Model';
import Contract from '../contract/Model.Contract';
import ContractRefund from '../contractRefund/Model.ContractRefund';
import contractCancellationListApi from './list/Api.ContractCancellation.List';

export default class ContractCancellation
  extends Model<Model.IContractCancellation>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IContractCancellation>
{
  id: number;
  type: Model.Enum.ContractCancellationTypes;
  cancellationDateLocal: string;
  createdAtUtc: string;
  modifiedAtUtc: string;
  odometerReading?: number;
  reason?: string;
  reasonDescription?: string;
  contractId: number;
  contract: Contract;
  contractRefund?: ContractRefund;

  //#region Old contract refund flow
  refundDateAtLocal?: string = undefined;
  refundPricingDistributions?: Utils.PricingDistribution = undefined;
  refundDistributorDistributions?: Utils.PricingDistribution = undefined;
  refundEnhancements?: Array<Utils.ContractEnhancementRefund> = undefined;
  refundSubfees?: Array<Utils.SurchargeInfo> = undefined;
  //#endregion

  constructor(
    data: Partial<Model.IContractCancellation> | Utils.FormData<Model.IContractCancellation>,
    language?: Locale.Languages
  ) {
    super(
      {
        contract: Contract,
        contractRefund: ContractRefund,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.id.toString(),
    };
  }

  static async list(body?: Api.Core.ContractCancellation.List.IRequest) {
    const { payload, ...rest } = await contractCancellationListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ContractCancellation(it)),
        count: payload.count,
      },
    };
  }
}
